import React from "react";
import { Timeline, Events, UrlButton, ImageEvent } from "@merc/react-timeline";

// projects
import L_CollabDocs from "../../assets/img/projects/CollabDocs.gif";
import L_e_commerce from "../../assets/img/projects/e_commercegif.gif";
import L_chatapp from "../../assets/img/projects/chatapp.gif";
import L_VybeCabs from "../../assets/img/projects/vybecabs.svg";
import L_Serviots from "../../assets/img/projects/serviots.jpg";

import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

// skills
import L_REACT from "../../assets/img/skills/react.svg";
import L_REDUX from "../../assets/img/skills/redux.svg";
import L_NODE_JS from "../../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../../assets/img/skills/express.svg";
import L_MONGODB from "../../assets/img/skills/mongodb.svg";
import Image from "react-bootstrap/Image";
import L_MATERIALUI from "../../assets/img/skills/material-ui-1.svg";
import L_STYLED_COMP from "../../assets/img/skills/styled-components.svg";
import L_SocketIO from "../../assets/img/skills/socket-io-svgrepo-com.svg";
import L_ChakraUI from "../../assets/img/skills/chakra-ui-icon.svg";
import L_Cloudinary from "../../assets/img/skills/cloudinary.png";
import L_NEXT_JS from "../../assets/img/skills/next-js.svg";
import L_TYPESCRIPT from "../../assets/img/skills/typescript.svg";
import L_TAILWIND from "../../assets/img/skills/tailwindcss.svg";
import L_WEBSOCKETS from "../../assets/img/skills/websockets.svg";
import L_MONGOOSE from "../../assets/img/skills/mongoose.svg";
import L_CICD from "../../assets/img/skills/cicd.svg";
import L_GROQ from "../../assets/img/skills/groq.svg";
import L_TIPTAP from "../../assets/img/skills/tiptap.svg";
import L_ZOD from "../../assets/img/skills/zod.svg";
import L_NEXTAUTH from "../../assets/img/skills/nextauth.svg";
import L_NESTJS from "../../assets/img/skills/nestjs.svg";
import L_REDIS from "../../assets/img/skills/redis.svg";
import L_BULLMQ from "../../assets/img/skills/bullmq.svg";
import L_DOCKER from "../../assets/img/skills/docker.svg";
import L_VERCEL from "../../assets/img/skills/vercel.svg";

import "./projects-timeline.styles.css";

const Tech = ({ src, name, className = "image-style m-1" }) => (
  <li>
    <span className="p-2">
      <Image src={src} alt={name} rounded className={className}></Image> {name}
    </span>
  </li>
);

const TimeLine = () => {
  return (
    <div>
      <h1 className="pt-3 text-center font-details-b pb-3">PROJECTS</h1>
      <Timeline>
        <Events>
          {/* Project: Collab Docs — Local-First Collaborative Document Editor */}
          <ImageEvent
            className="text-center"
            text="Collab Docs"
            src={L_CollabDocs}
            alt="Collab Docs"
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;A production-grade local-first collaborative
                        document editor — combining offline editing, real-time sync, version control,
                        secure multi-user access, and AI-assisted writing.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>
                            Local-first architecture — edit documents offline with IndexedDB as
                            primary storage, zero network blocking
                          </li>
                          <li>
                            Background sync engine — automatic merge on reconnect without
                            overwriting offline work
                          </li>
                          <li>
                            Real-time collaboration over WebSockets with Y.js YATA deterministic
                            conflict resolution
                          </li>
                          <li>
                            Rich text editing with Tiptap 3 and real-time collaboration extensions
                          </li>
                          <li>
                            Version history &amp; time travel — save named snapshots and restore
                            without corrupting live collaborators
                          </li>
                          <li>
                            Invite collaborators by email with Owner, Editor, and Viewer role
                            management
                          </li>
                          <li>
                            Role-based access enforced at WebSocket level — viewers cannot push
                            document updates
                          </li>
                          <li>
                            AI writing assistant — continue writing, summarize, fix grammar via
                            Groq Llama 3.3 70B
                          </li>
                          <li>
                            Production safeguards — NextAuth JWT auth, Zod payload validation, 5 MB
                            sync limits, and tenant-scoped MongoDB access
                          </li>
                          <li>
                            Split production architecture — Next.js on Vercel + Y.js WebSocket
                            server on Railway, with GitHub Actions CI/CD
                          </li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_NEXT_JS}
                                alt="Next.js"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Next.js 16
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_TYPESCRIPT}
                                alt="TypeScript"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              TypeScript
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REACT}
                                alt="React"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              React
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_NODE_JS}
                                alt="Node.js"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Node.js
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_MONGODB}
                                alt="MongoDB"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              MongoDB
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_MONGOOSE}
                                alt="Mongoose"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Mongoose
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_TAILWIND}
                                alt="Tailwind CSS"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Tailwind CSS
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_TIPTAP}
                                alt="Tiptap"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Tiptap
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_WEBSOCKETS}
                                alt="WebSockets"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              WebSockets / Y.js
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_NEXTAUTH}
                                alt="NextAuth"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              NextAuth
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_ZOD}
                                alt="Zod"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Zod
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_CICD}
                                alt="CI/CD"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              CI/CD
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_GROQ}
                                alt="Groq"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Groq AI
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton
                  href="https://collab-doc-editor-rho.vercel.app/"
                  target="_blank"
                >
                  SEE LIVE
                </UrlButton>
                <UrlButton
                  href="https://github.com/Shiva7781/collab-doc-editor"
                  target="_blank"
                >
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>


          {/* Project: Vybe Cabs — Real-Time Driver Allocation System */}
          <ImageEvent className="text-center" text="Vybe Cabs" src={L_VybeCabs} alt="Vybe Cabs">
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;A ride-hailing backend that finds the
                        nearest available drivers, notifies several at once over WebSockets, and
                        guarantees exactly one of them is assigned, even when multiple drivers
                        accept at the same instant.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>Nearby-driver search with Redis GEO (GEOSEARCH within a radius)</li>
                          <li>
                            Race-free acceptance: a single atomic Redis Lua script (SET NX) picks
                            exactly one winner; the rest get 409
                          </li>
                          <li>
                            BullMQ delayed jobs handle offer timeouts and retry with a wider search
                            radius (3 km → 6 km → 10 km)
                          </li>
                          <li>
                            Explicit ride state machine: REQUESTED → SEARCHING → ASSIGNED / TIMEOUT
                            / CANCELLED, with a per-round audit trail
                          </li>
                          <li>Idempotent accept: retrying a winning request returns the same result</li>
                          <li>
                            Automated concurrency test script proving the exactly-one-winner
                            guarantee
                          </li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <Tech src={L_NESTJS} name="NestJS" />
                          <Tech src={L_TYPESCRIPT} name="TypeScript" />
                          <Tech src={L_REDIS} name="Redis" />
                          <Tech src={L_BULLMQ} name="BullMQ" />
                          <Tech src={L_MONGODB} name="MongoDB" />
                          <Tech src={L_SocketIO} name="Socket.IO" />
                          <Tech src={L_DOCKER} name="Docker" />
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-center flex-nowrap text-center">
                <UrlButton href="https://github.com/Shiva7781/VybeCabs" target="_blank">
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: Serviots — Co-working Space Desk & Room Booking */}
          <ImageEvent className="text-center" text="Serviots" src={L_Serviots} alt="Serviots">
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;A full-stack co-working space booking
                        platform: members browse desks and meeting rooms and book time slots, while
                        admins manage spaces and bookings. Double-booking is prevented at the
                        database level.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>
                            No double-booking: a unique MongoDB index on space + date + slot, with
                            compensating rollback (verified with 8 concurrent requests → 1 success,
                            7 × 409)
                          </li>
                          <li>
                            JWT access tokens kept in memory, plus httpOnly refresh-token rotation
                            with reuse detection
                          </li>
                          <li>Role-based access for members and admins</li>
                          <li>Rate limiting and request validation on the API</li>
                          <li>Email notifications for bookings</li>
                          <li>
                            One-command Docker Compose setup; deployed on Vercel (frontend) +
                            Render (API) + MongoDB Atlas
                          </li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <Tech src={L_REACT} name="React" />
                          <Tech src={L_NODE_JS} name="Node.js" />
                          <Tech src={L_EXPRESS} name="Express" className="image-style1 m-1" />
                          <Tech src={L_MONGODB} name="MongoDB" />
                          <Tech src={L_DOCKER} name="Docker" />
                          <Tech src={L_VERCEL} name="Vercel" />
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton href="https://frontend-six-phi-79.vercel.app" target="_blank">
                  SEE LIVE
                </UrlButton>
                <UrlButton href="https://github.com/Shiva7781/Serviots" target="_blank">
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: E-Commerce */}
          <ImageEvent className="text-center" text="E-Commerce" src={L_e_commerce} alt="E-Commerce">
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;A full-stack MERN commerce platform
                        that handles 10k+ SKUs with sub-200ms API responses. It covers the full
                        order lifecycle, from browsing to Stripe checkout.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>
                            Compound MongoDB indexing keeps catalog queries under 200ms across 10k+
                            SKUs
                          </li>
                          <li>JWT-based authentication with protected routes</li>
                          <li>Stripe payment integration and full order lifecycle</li>
                          <li>Real-time inventory sync between cart and stock</li>
                          <li>Product filters (size, color) and sorting</li>
                          <li>Cart state managed with Redux Toolkit</li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_NODE_JS}
                                alt="Node.js"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Node.js
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_EXPRESS}
                                alt="Express"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              Express
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_MONGODB}
                                alt="MongoDB"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              MongoDB
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REACT}
                                alt="React"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              React
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REDUX}
                                alt="Redux Toolkit"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Redux Toolkit
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_MATERIALUI}
                                alt="Material UI"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Material UI
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_STYLED_COMP}
                                alt="Styled Components"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              Styled Components
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton href="https://shiva7781e-commerce.netlify.app/" target="_blank">
                  SEE LIVE
                </UrlButton>
                <UrlButton href="https://github.com/Shiva7781/E-commerce" target="_blank">
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: Chat App ( MERN ) */}
          <ImageEvent className="text-center" text="Chat App" src={L_chatapp} alt="Chat App">
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;A real-time messaging platform built on
                        Socket.IO that supports 100+ concurrent users across one-on-one and group
                        conversations, with graceful reconnection when the network drops.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>
                            Real-time one-on-one and group messaging over Socket.IO, built for
                            100+ concurrent users
                          </li>
                          <li>
                            Graceful WebSocket reconnection: sessions recover automatically after
                            network drops
                          </li>
                          <li>Live typing indicators and unread-message notifications</li>
                          <li>
                            Group admin controls: create, rename, add and remove members; members
                            can leave
                          </li>
                          <li>Sign-in/sign-up authentication and user search by name or email</li>
                          <li>Profile and group-info modals; image uploads via Cloudinary</li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_NODE_JS}
                                alt="Node.js"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Node.js
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_EXPRESS}
                                alt="Express"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              Express
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_MONGODB}
                                alt="MongoDB"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              MongoDB
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REACT}
                                alt="React"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              React
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_Cloudinary}
                                alt="Cloudinary"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Cloudinary
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_SocketIO}
                                alt="Socket.IO"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Socket.IO
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_ChakraUI}
                                alt="Chakra UI"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Chakra UI
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton href="https://chat-app-shiva7781.netlify.app/" target="_blank">
                  SEE LIVE
                </UrlButton>
                <UrlButton href="https://github.com/Shiva7781/chat_app" target="_blank">
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

        </Events>
      </Timeline>
    </div>
  );
};

export default TimeLine;
